export default "__VITE_ASSET__D0F$DvCI__"